import { uuid4 } from './uuid';
var SimpleEvent = /** @class */ (function () {
    function SimpleEvent() {
        this.handlers = new Map();
        this.on = this.on.bind(this);
        this.trigger = this.trigger.bind(this);
    }
    SimpleEvent.prototype.on = function (handler) {
        var _this = this;
        var uuid = uuid4();
        this.handlers.set(uuid, handler);
        return function () {
            _this.handlers.delete(uuid);
        };
    };
    SimpleEvent.prototype.trigger = function (event) {
        Array.from(this.handlers.values()).forEach(function (handler) { return handler(event); });
    };
    return SimpleEvent;
}());
export default SimpleEvent;
//# sourceMappingURL=simpleEvent.js.map